export default class ItemRequisicao {
  constructor(
    id_requisicao = null,
    id_item = null,
    id_produto,
    id_unidade,
    produto,
    unidade,
    qtde_requisitada = 0,
    qtde_unidade,
    lote_padrao,
    barras = []
  ) {
    this.id_requisicao = id_requisicao;
    this.id_item = id_item;
    this.id_produto = id_produto;
    this.id_unidade = id_unidade;
    this.produto = produto;
    this.unidade = unidade;
    this.qtde_requisitada = qtde_requisitada;
    this.qtde_unidade = qtde_unidade;
    this.lote_padrao = lote_padrao;
    this.barras = barras;
  }
}